var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57998_4350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.33301V12.6677",
    stroke: "#7474FF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6687 8.00098H3.33398",
    stroke: "#7474FF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.33301V12.6677",
    stroke: "#7474FF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6687 8.00098H3.33398",
    stroke: "#7474FF",
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57998_4350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.097e1ed47c37510774c1d4ce588d74ec.svg";
export { ForwardRef as ReactComponent };